import React, { useState, useEffect } from 'react';
import { 
  Menu, X, Mail, 
  Briefcase, 
  Code, Layout, Send, Mic, Sparkles, Languages, BookOpen,
  Linkedin, Instagram, Download, Video, ChevronLeft, ChevronRight
} from 'lucide-react';
import './App.css';

// Custom TikTok Icon SVG since it's not standard in Lucide
const TikTokIcon = ({ className }) => (
  <svg 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91.04.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93v7.2c0 1.63-.53 3.23-1.54 4.54-1.07 1.36-2.61 2.22-4.32 2.4-1.78.18-3.62-.15-5.07-1.16-1.57-1.1-2.5-2.88-2.63-4.81-.13-1.92.54-3.86 1.83-5.23 1.35-1.42 3.32-2.12 5.25-1.99v4c-1.1-.06-2.22.45-2.85 1.35-.55.78-.71 1.8-.44 2.73.28.98 1.09 1.75 2.05 2.02.99.28 2.08.06 2.86-.55.77-.61 1.25-1.53 1.29-2.52V.02h-.01z"/>
  </svg>
);

// Custom WhatsApp Icon SVG
const WhatsAppIcon = ({ size = 24, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/>
  </svg>
);

// Image URLs
const PROFILE_IMAGE = "https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/5dcm9fs2_InShot_20260101_004825290.jpg.jpeg";
const EMERALD_BINTARO_LOGO = "https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/kifbjd6u_Emerald%20Bintaro.jpeg";
const SILOAM_LOGO = "https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/cwe4k62b_Siloam.png";
const BURGARI_LOGO = "https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/t142yaij_Burgaari.png";
const MRDIY_LOGO = "https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/87dju36e_MR%20DIY.jpeg";
const LERVIA_LOGO = "https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/zpguqwmg_LERVIA.jpeg";
const SUNCO_LOGO = "https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/d751h63u_sunco.png";
const GPU_LOGO = "https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/ejg0ucw3_GPU.jpeg";
const IKN_LOGO = "https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/7tgxsp92_IKN.jpg";
const DHL_LOGO = "https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/9m14k9bg_DHL.png";
const ZTE_LOGO = "https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/corf5avi_ZTE.jpg";
const DHARMAIS_LOGO = "https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/t2bwu87i_RS%20kanker%20Dharmais.jpeg";
const PAMA_LOGO = "https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/cmjd7w74_Pama%20Persada.jpeg";
const JOTUN_LOGO = "https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/lwsz0tbl_Jotun.png";
const DFLASH_LOGO = "https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/16guwjr2_Dflash.jpeg";
const SANYO_LOGO = "https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/my3o6vrl_Sanyo.jpeg";
const DANAPAINT_LOGO = "https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/bz73gx0o_Dana%20Paint.jpeg";
const BINTARO_PLAZA_LOGO = "https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/ixplzzaf_Bintaro%20Plaza%20Residence.jpeg";

// CV PDF URL
const CV_URL = "https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/6hfl5boa_%5BCV%5D%20Ireta%20Salsabila%20Putri.pdf";

const App = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [projectPage, setProjectPage] = useState(1);

  // Additional Projects Data with pagination
  const additionalProjects = [
    // Page 1 - Top Coffee Videos
    [
      { type: 'video', title: 'Voice Over for Top Coffee', description: 'Professional voice-over work showcasing my talent in commercial advertising', url: 'https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/jdrbwe3u_VO%20for%20Top%20Coffee.mp4' },
      { type: 'video', title: 'Voice Over for Top Coffee (2)', description: 'Another creative voice-over piece demonstrating versatility in delivery', url: 'https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/huglvbz0_VO%20for%20Top%20Coffee%20%282%29.mp4' },
    ],
    // Page 2 - Nutrijell Videos
    [
      { type: 'video', title: 'Voice Over for Nutrijell', description: 'Voice-over work for Nutrijell commercial', url: 'https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/bq6pe10z_Voice%20Over%20for%20Nutrijell.mp4' },
      { type: 'video', title: 'Voice Over for Nutrijell 2', description: 'Second Nutrijell voice-over project', url: 'https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/hp0le2yw_Voice%20Over%20for%20Nutrijell%202.mp4' },
    ],
    // Page 3 - More Projects
    [
      { type: 'video', title: 'Voice Over Nutrijell 3', description: 'Third Nutrijell voice-over piece', url: 'https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/ipr2hj0s_Voice%20Over%20Nutrijell%203.mp4' },
      { type: 'video', title: 'Voice Over MR.DIY', description: 'Voice-over work for MR.DIY commercial', url: 'https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/lqg4eoxw_Voice%20Over%20Mr%20DIY.mp4' },
    ],
    // Page 4 - Host Webinar
    [
      { type: 'image', title: 'Host Webinar Exacta', description: 'Hosting webinar event for Exacta Technology', url: 'https://customer-assets.emergentagent.com/job_irene-portfolio/artifacts/ew79x2xx_Host%20Webinar%20Exacta.jpeg' },
    ],
  ];

  const totalPages = additionalProjects.length;

  // Animation on scroll logic
  useEffect(() => {
    // Reveal animation observer (triggers classes)
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
            // Unobserve after triggering once to keep it visible
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -50px 0px" }
    );

    document.querySelectorAll('.reveal').forEach((el) => {
      revealObserver.observe(el);
    });

    // Active Navigation Link observer
    const navObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.4 }
    );

    document.querySelectorAll('section[id]').forEach((section) => {
      navObserver.observe(section);
    });

    return () => {
      revealObserver.disconnect();
      navObserver.disconnect();
    };
  }, []);

  const scrollTo = (id) => {
    setIsMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navLinks = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About Me' },
    { id: 'skills', label: 'Skills' },
    { id: 'additional-skills', label: 'Additional Skills & Talents' },
    { id: 'experience', label: 'Experience' },
    { id: 'portfolio', label: 'Portfolio' },
    { id: 'additional-projects', label: 'Additional Projects' },
    { id: 'contact', label: 'Contact' },
  ];

  const techSkills = [
    { name: 'Social Media Maintenance', level: 95 },
    { name: 'Copy Writing & Content Planning', level: 85 },
    { name: 'Project Management & Tracking', level: 95 },
    { name: 'Meta Ads', level: 80 },
    { name: 'Budget Allocation (Invoice, Quotation, Budget Ads)', level: 90 },
    { name: 'KPI & Timeline Monitoring', level: 95 },
  ];

  const softSkills = [
    'Client Relations', 'Account Management', 'Leadership', 
    'Communication', 'Teamwork', 'Problem Solving', 'Adaptability'
  ];

  const additionalSkills = [
    { name: 'Voice Over Skill', icon: <Mic size={28} /> },
    { name: 'Hand Talent', icon: <Sparkles size={28} /> },
    { name: 'Japanese Interpreter', icon: <Languages size={28} /> },
    { name: 'Japanese Teacher', icon: <BookOpen size={28} /> },
    { name: 'Host', icon: <Video size={28} /> },
  ];

  const featuredClients = [
    { name: 'Emerald Bintaro', link: 'https://www.instagram.com/emeraldbintaroofficial', image: EMERALD_BINTARO_LOGO },
    { name: 'Bintaro Plaza Residence', link: 'https://www.instagram.com/bintaroplazaresidences', image: BINTARO_PLAZA_LOGO },
    { name: 'Danapaint', link: 'https://www.instagram.com/danapaint', image: DANAPAINT_LOGO },
    { name: 'Sanyo', link: 'https://www.instagram.com/sanyoindonesia', image: SANYO_LOGO },
    { name: 'DFlash', link: 'https://www.instagram.com/dflashid', image: DFLASH_LOGO },
    { name: 'Jotun', link: 'https://www.instagram.com/jotunindonesia', image: JOTUN_LOGO },
    { name: 'Pama Persada', link: 'https://www.instagram.com/pamapersadaofficial', image: PAMA_LOGO },
    { name: 'RS Kanker Dharmais', link: 'https://www.instagram.com/rskankerdharmais', image: DHARMAIS_LOGO },
    { name: 'ZTE', link: 'https://www.instagram.com/ztedevices', image: ZTE_LOGO },
    { name: 'DHL', link: 'https://www.instagram.com/dhlexpressid', image: DHL_LOGO },
    { name: 'IKN', link: 'https://www.instagram.com/ikn_id', image: IKN_LOGO },
    { name: 'GPU', link: 'https://www.instagram.com/sobatgpu', image: GPU_LOGO },
    { name: 'SunCo', link: 'https://www.instagram.com/sunco_id', image: SUNCO_LOGO },
    { name: 'Lervia', link: 'https://www.instagram.com/lerviabeauty', image: LERVIA_LOGO },
    { name: 'Burgari', link: 'https://www.instagram.com/burgari_official', image: BURGARI_LOGO },
    { name: 'Siloam', link: 'https://www.instagram.com/siloamhearthospital', image: SILOAM_LOGO },
    { name: 'MR.DIY', link: 'https://www.instagram.com/mrdiy.indonesia', image: MRDIY_LOGO },
  ];

  const handleWhatsAppSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const name = form.user_name.value;
    const email = form.user_email.value;
    const subject = form.user_subject.value;
    const message = form.user_message.value;

    const waText = `Hello Irene!\n\nMy name is *${name}* (${email}).\n\n*Subject: ${subject}*\n\nMessage:\n${message}`;
    const encodedText = encodeURIComponent(waText);
    const waUrl = `https://wa.me/6287776147834?text=${encodedText}`;

    window.open(waUrl, '_blank');
  };

  return (
    <div className="min-h-screen bg-pink-50 font-sans text-gray-800 selection:bg-pink-300 selection:text-gray-900">
      
      {/* Navigation Bar */}
      <nav className="fixed top-0 w-full bg-pink-50/90 backdrop-blur-md z-50 border-b border-pink-100 shadow-sm transition-all">
        <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center">
          <div 
            className="text-2xl font-bold tracking-tighter cursor-pointer text-gray-800"
            onClick={() => scrollTo('home')}
            data-testid="logo-home"
          >
            Ireta<span className="text-pink-500">.</span>
          </div>
          
          {/* Desktop Nav */}
          <div className="hidden md:flex space-x-8">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollTo(link.id)}
                data-testid={`nav-${link.id}`}
                className={`text-sm font-bold transition-colors hover:text-pink-500 ${
                  activeSection === link.id ? 'text-pink-500' : 'text-gray-600'
                }`}
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* Mobile Nav Toggle */}
          <button 
            className="md:hidden text-gray-600 hover:text-pink-500"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden absolute top-full left-0 w-full bg-pink-50 border-b border-pink-100 shadow-lg py-4 flex flex-col space-y-4 px-6 reveal reveal-down active" data-testid="mobile-menu">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollTo(link.id)}
                className="text-left text-gray-600 hover:text-pink-500 font-bold"
              >
                {link.label}
              </button>
            ))}
          </div>
        )}
      </nav>

      {/* Main Content */}
      <main className="pt-20">
        
        {/* HERO SECTION */}
        <section id="home" className="min-h-[90vh] flex items-center max-w-6xl mx-auto px-6 py-12" data-testid="hero-section">
          <div className="flex flex-col md:flex-row items-center justify-between w-full gap-12">
            <div className="w-full md:w-1/2 space-y-6 order-2 md:order-1 reveal reveal-left">
              <p className="text-pink-500 font-bold tracking-wide uppercase text-sm bg-pink-100 inline-block px-4 py-1.5 rounded-full">Welcome to my portfolio</p>
              <div>
                <h1 className="text-5xl md:text-6xl font-bold leading-tight text-gray-900 mb-2">
                  Hi, I'm <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-pink-300">Ireta Salsabila Putri</span>
                </h1>
                <p className="text-xl text-pink-500 font-medium italic">You can call me Irene</p>
              </div>
              <h2 className="text-2xl text-gray-700 font-medium">Senior Account Executive & Project Manager</h2>
              <p className="text-gray-600 text-lg leading-relaxed max-w-lg">
                With over 8+ years of experience in digital marketing agencies. I specialize in client relations, end-to-end project management, and driving successful campaigns from concept to execution.
              </p>
              <div className="flex flex-wrap gap-4 pt-4">
                <button 
                  onClick={() => scrollTo('portfolio')}
                  className="px-8 py-3 bg-pink-400 hover:bg-pink-500 text-white font-bold rounded-full transition-all shadow-md shadow-pink-200 hover:shadow-lg transform hover:-translate-y-1"
                  data-testid="view-portfolio-btn"
                >
                  View Portfolio
                </button>
                <a 
                  href={CV_URL}
                  download="[CV] Ireta Salsabila Putri.pdf"
                  className="px-8 py-3 bg-pink-500 hover:bg-pink-600 text-white font-bold rounded-full transition-all shadow-md shadow-pink-200 hover:shadow-lg transform hover:-translate-y-1 flex items-center gap-2"
                  data-testid="download-cv-btn"
                >
                  <Download size={18} />
                  Download CV
                </a>
                <button 
                  onClick={() => scrollTo('contact')}
                  className="px-8 py-3 border-2 border-pink-400 text-pink-600 hover:bg-pink-100 font-bold rounded-full transition-all"
                  data-testid="contact-me-btn"
                >
                  Contact Me
                </button>
              </div>
            </div>
            
            <div className="w-full md:w-1/2 flex justify-center order-1 md:order-2 reveal reveal-right delay-200">
              <div className="relative w-72 h-72 md:w-96 md:h-96">
                {/* Outer Breathing Glow Circle */}
                <div className="absolute inset-[-20px] rounded-full animate-outer-glow pointer-events-none z-0"></div>
                
                {/* Decorative Offset Circle */}
                <div className="absolute top-4 -left-4 w-full h-full border-4 border-pink-200 rounded-full pointer-events-none animate-float-slow"></div>
                
                {/* Profile Image Area with Inner Glow */}
                <div className="relative w-full h-full flex items-center justify-center z-10">
                  {/* Inner Glow Layer */}
                  <div className="absolute inset-[-10px] rounded-full bg-pink-400 blur-[15px] animate-breath-glow pointer-events-none z-0"></div>
                  
                  {/* Actual Image Container */}
                  <div className="relative w-full h-full bg-pink-100 rounded-full overflow-hidden border-4 border-white flex items-center justify-center z-10 shadow-xl">
                    <img 
                      src={PROFILE_IMAGE}
                      alt="Ireta Salsabila Putri" 
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                      data-testid="profile-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ABOUT SECTION */}
        <section id="about" className="py-24 bg-pink-100" data-testid="about-section" itemScope itemType="https://schema.org/Person">
          <div className="max-w-6xl mx-auto px-6">
            <div className="flex flex-col md:flex-row gap-16 items-center">
              <div className="w-3/4 sm:w-1/2 md:w-1/4 mx-auto reveal reveal-scale">
                <div className="aspect-square rounded-3xl bg-gradient-to-tr from-pink-400 to-pink-200 shadow-xl shadow-pink-200 p-6 flex flex-col justify-end relative overflow-hidden group">
                  <div className="absolute inset-0 bg-white/20 group-hover:bg-white/0 transition-all duration-500"></div>
                  <h3 className="text-5xl font-extrabold text-white mb-2 drop-shadow-md">8+</h3>
                  <p className="text-pink-50 font-medium text-sm drop-shadow-sm leading-tight">Years of Experience in Digital Marketing & Account Management</p>
                </div>
              </div>
              <div className="w-full md:w-3/4 space-y-6 reveal reveal-right delay-200">
                <div className="flex items-center space-x-4 mb-4">
                  <span className="h-1 w-12 bg-pink-400 rounded-full"></span>
                  <h2 className="text-3xl font-bold text-gray-900">About Me</h2>
                </div>
                
                {/* Personal Info with SEO */}
                <div className="flex flex-wrap gap-4 text-sm">
                  <span className="px-4 py-2 bg-white rounded-full text-gray-700 font-medium shadow-sm border border-pink-100">
                    <span itemProp="birthDate" content="1998-12-11">Born 11 December 1998</span>
                  </span>
                  <span className="px-4 py-2 bg-white rounded-full text-gray-700 font-medium shadow-sm border border-pink-100">
                    <span itemProp="nationality">Indonesian</span>
                  </span>
                  <span className="px-4 py-2 bg-white rounded-full text-gray-700 font-medium shadow-sm border border-pink-100">
                    <span itemProp="jobTitle">Senior Account Executive</span>
                  </span>
                </div>

                <p className="text-gray-700 leading-relaxed text-lg" itemProp="description">
                  I am <span itemProp="name" className="font-semibold">Ireta Salsabila Putri</span>, a highly driven <strong>Senior Account Executive</strong> and <strong>Project Manager</strong> with a Bachelor's Degree in Japanese Literature from STBA JIA. My career pivot into the <strong>digital marketing</strong> realm has equipped me with a unique blend of analytical thinking and creative problem-solving.
                </p>
                <p className="text-gray-700 leading-relaxed text-lg">
                  With over <strong>8 years of professional experience</strong> in the <strong>advertising agency industry</strong>, I have honed my expertise in acting as the key bridge between clients and creative teams. My core competencies include <strong>client relationship management</strong>, <strong>budget allocation</strong>, <strong>KPI monitoring</strong>, <strong>social media marketing</strong>, and <strong>Meta Ads optimization</strong>. From onboarding new clients to orchestrating offline activations, my passion lies in translating client visions into measurable, impactful results.
                </p>
                <p className="text-pink-700 font-medium leading-relaxed text-lg italic border-l-4 border-pink-400 pl-6 py-2 bg-pink-50/50 rounded-r-lg">
                  "Continuously seeking new opportunities to develop my work ethics, deliver exceptional results, and expand my professional connections."
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* SKILLS SECTION */}
        <section id="skills" className="py-24 bg-pink-50" data-testid="skills-section">
          <div className="max-w-6xl mx-auto px-6">
            <div className="text-center mb-16 reveal reveal-up">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">My Skills & Expertise</h2>
              <div className="h-1.5 w-24 bg-pink-400 mx-auto rounded-full"></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              {/* Technical Skills */}
              <div className="bg-white p-8 rounded-3xl shadow-lg shadow-pink-100/50 border border-pink-100 hover-lift reveal reveal-left delay-100">
                <div className="flex items-center space-x-4 mb-8">
                  <div className="p-3 bg-pink-100 rounded-xl text-pink-500 hover-wiggle"><Code size={28} /></div>
                  <h3 className="text-2xl font-bold text-gray-800">Technical Skills</h3>
                </div>
                <div className="space-y-6">
                  {techSkills.map((skill, index) => (
                    <div key={index} className="reveal reveal-fade" style={{ transitionDelay: `${index * 100}ms` }}>
                      <div className="flex justify-between mb-2">
                        <span className="text-sm font-bold text-gray-700">{skill.name}</span>
                        <span className="text-sm font-bold text-pink-500">{skill.level}%</span>
                      </div>
                      <div className="w-full bg-pink-50 rounded-full h-3 overflow-hidden">
                        <div 
                          className="bg-gradient-to-r from-pink-300 to-pink-500 h-3 rounded-full transition-all duration-1000 ease-out shadow-sm relative overflow-hidden" 
                          style={{ width: `${skill.level}%` }}
                        >
                          <div className="absolute inset-0 animate-shimmer"></div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Soft Skills */}
              <div className="bg-white p-8 rounded-3xl shadow-lg shadow-pink-100/50 border border-pink-100 hover-lift reveal reveal-right delay-200">
                <div className="flex items-center space-x-4 mb-8">
                  <div className="p-3 bg-pink-100 rounded-xl text-pink-500 hover-wiggle"><Layout size={28} /></div>
                  <h3 className="text-2xl font-bold text-gray-800">Soft Skills</h3>
                </div>
                <div className="flex flex-wrap gap-3">
                  {softSkills.map((skill, index) => (
                    <span 
                      key={index}
                      className="px-5 py-3 bg-pink-50 text-pink-700 rounded-xl text-sm font-bold border border-pink-100 hover:border-pink-300 hover:bg-pink-100 hover:scale-105 transition-all cursor-default shadow-sm"
                      style={{ transitionDelay: `${index * 50}ms` }}
                    >
                      {skill}
                    </span>
                  ))}
                </div>
                
                {/* Languages Mini-section */}
                <div className="mt-10">
                  <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center"><span className="w-8 h-1 bg-pink-300 mr-3 rounded-full"></span> Languages</h4>
                  <div className="space-y-4 bg-pink-50/50 p-6 rounded-2xl border border-pink-100">
                    <div className="flex justify-between items-center border-b border-pink-100 pb-3">
                      <span className="text-gray-700 font-semibold">Bahasa Indonesia</span>
                      <span className="text-xs font-bold px-3 py-1 bg-pink-200 text-pink-800 rounded-lg">Native</span>
                    </div>
                    <div className="flex justify-between items-center border-b border-pink-100 pb-3">
                      <span className="text-gray-700 font-semibold">Japanese</span>
                      <span className="text-xs font-bold px-3 py-1 bg-pink-200 text-pink-800 rounded-lg">Fluent</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-700 font-semibold">English</span>
                      <span className="text-xs font-bold px-3 py-1 bg-pink-200 text-pink-800 rounded-lg">Intermediate</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ADDITIONAL SKILLS SECTION */}
        <section id="additional-skills" className="py-24 bg-white" data-testid="additional-skills-section">
          <div className="max-w-6xl mx-auto px-6">
            <div className="text-center mb-16 reveal reveal-up">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Additional Skills & Talents</h2>
              <div className="h-1.5 w-24 bg-pink-400 mx-auto rounded-full"></div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
              {additionalSkills.map((skill, index) => (
                <div 
                  key={index} 
                  className="bg-pink-50 p-8 rounded-3xl shadow-sm border border-pink-100 hover:shadow-xl hover:shadow-pink-200 hover:-translate-y-2 transition-all duration-300 flex flex-col items-center justify-center text-center group reveal reveal-scale"
                  style={{ transitionDelay: `${index * 150}ms` }}
                >
                  <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center text-pink-400 shadow-md group-hover:scale-110 group-hover:bg-pink-400 group-hover:text-white transition-all duration-300 mb-6 rotate-3 group-hover:rotate-0">
                    {skill.icon}
                  </div>
                  <h3 className="text-lg font-bold text-gray-800">{skill.name}</h3>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* EXPERIENCE SECTION */}
        <section id="experience" className="py-24 bg-pink-100" data-testid="experience-section">
          <div className="max-w-4xl mx-auto px-6">
            <div className="text-center mb-16 reveal reveal-up">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Professional Experience</h2>
              <div className="h-1.5 w-24 bg-pink-400 mx-auto rounded-full"></div>
            </div>

            <div className="space-y-12 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-1 before:bg-gradient-to-b before:from-pink-400 before:via-pink-200 before:to-transparent">
              
              {/* Exp 1 */}
              <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group reveal reveal-up delay-100">
                <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-pink-100 bg-pink-500 text-white shadow-lg shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 animate-timeline-pulse">
                  <Briefcase size={20} />
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] bg-white p-6 rounded-2xl shadow-md shadow-pink-200/50 border border-pink-100 hover-lift">
                  <div className="flex flex-col mb-2">
                    <span className="text-pink-500 font-extrabold text-sm mb-1 uppercase tracking-wider">Mar 2024 - Present</span>
                    <h3 className="text-xl font-bold text-gray-900">Senior Account Executive</h3>
                    <h4 className="text-md font-bold text-pink-400">Acom Digital Kreasi</h4>
                  </div>
                  <p className="text-gray-600 text-sm mb-4 font-medium bg-pink-50 inline-block px-3 py-1 rounded-md">
                    Clients: GPU, SunCo, Lervia, Burgari, Siloam, MR.DIY
                  </p>
                  <ul className="text-sm text-gray-700 list-disc pl-5 space-y-2 marker:text-pink-400">
                    <li>Act as the key role for clients' concerns and needs.</li>
                    <li>Handle contracts, quotations, and invoices with retained and existing clients.</li>
                    <li>Ensure all project deliverables are fulfilled and timeline progresses without issues.</li>
                    <li>Lead meetings and prepare MOM.</li>
                  </ul>
                </div>
              </div>

              {/* Exp 2 */}
              <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group reveal reveal-up delay-200">
                <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-pink-100 bg-pink-300 text-white shadow-md shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2">
                  <Briefcase size={20} />
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] bg-white p-6 rounded-2xl shadow-md shadow-pink-200/50 border border-pink-100 hover-lift">
                  <div className="flex flex-col mb-2">
                    <span className="text-pink-400 font-extrabold text-sm mb-1 uppercase tracking-wider">Jul 2022 - Feb 2024</span>
                    <h3 className="text-xl font-bold text-gray-900">Account Manager</h3>
                    <h4 className="text-md font-bold text-pink-400">Krona</h4>
                  </div>
                  <p className="text-gray-600 text-sm mb-4 font-medium bg-pink-50 inline-block px-3 py-1 rounded-md">
                    Clients: JOTUN, PAMA PERSADA, Dharmais, ZTE, DHL, IKN
                  </p>
                  <ul className="text-sm text-gray-700 list-disc pl-5 space-y-2 marker:text-pink-400">
                    <li>Worked closely with Business Dev team for onboarding new clients.</li>
                    <li>Supervised Account Executives for ongoing SMM, KOL, Digital Ads, and Website projects.</li>
                    <li>Created execution plans including offline activations and event budgets.</li>
                    <li>Supervising the running of offline events (ensuring all requirements are met, briefing with event performers; MC, KOL, etc., coordinating with the community present at the event).</li>
                    <li>Coordinating with the entire team and division during the project.</li>
                  </ul>
                </div>
              </div>

              {/* Exp 3 */}
              <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group reveal reveal-up delay-300">
                <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-pink-100 bg-pink-300 text-white shadow-md shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2">
                  <Briefcase size={20} />
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] bg-white p-6 rounded-2xl shadow-md shadow-pink-200/50 border border-pink-100 hover-lift">
                  <div className="flex flex-col mb-2">
                    <span className="text-pink-400 font-extrabold text-sm mb-1 uppercase tracking-wider">Jan 2022 - Jun 2022</span>
                    <h3 className="text-xl font-bold text-gray-900">Account Manager</h3>
                    <h4 className="text-md font-bold text-pink-400">Andaf Corporation</h4>
                  </div>
                  <p className="text-gray-600 text-sm mb-4 font-medium bg-pink-50 inline-block px-3 py-1 rounded-md">
                    Clients: PP Property, Sanyo, BPOM, Danapaint
                  </p>
                  <ul className="text-sm text-gray-700 list-disc pl-5 space-y-2 marker:text-pink-400">
                    <li>Led a team of 5 Account Executives.</li>
                    <li>Managed projects achieving retention rates above 80%.</li>
                    <li>Systematized project tracking progress, boosting efficiency up to 50%.</li>
                    <li>Recorded existing clients and supervised teams to run the project according to the applicable KPIs & SOPs.</li>
                  </ul>
                </div>
              </div>

               {/* Exp 4 */}
               <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group reveal reveal-up delay-400">
                <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-pink-100 bg-pink-300 text-white shadow-md shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2">
                  <Briefcase size={20} />
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] bg-white p-6 rounded-2xl shadow-md shadow-pink-200/50 border border-pink-100 hover-lift">
                  <div className="flex flex-col mb-2">
                    <span className="text-pink-400 font-extrabold text-sm mb-1 uppercase tracking-wider">Aug 2019 - Dec 2021</span>
                    <h3 className="text-xl font-bold text-gray-900">Account Executive</h3>
                    <h4 className="text-md font-bold text-pink-400">Andaf Corporation</h4>
                  </div>
                  <ul className="text-sm text-gray-700 list-disc pl-5 space-y-2 marker:text-pink-400">
                    <li>Maintained timeline & KPI for 10+ property clients with 80% satisfaction rate.</li>
                    <li>Managed ad budgets across 5+ platforms, generating daily hot leads.</li>
                    <li>Increased downloaded users up to 2000+ for app clients via targeted ads.</li>
                    <li>Worked closely with 4+ cross functional department such as advertiser, graphic designer, and content writer to increased downloaded users up to 2000+ for DFlash app client with ad targeting and redesigned ad content.</li>
                    <li>Successfully boosted hot leads for Grand Zamzam Residence clients up to 80%.</li>
                  </ul>
                </div>
              </div>

              {/* Exp 5 */}
              <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group reveal reveal-up delay-500">
                <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-pink-100 bg-pink-300 text-white shadow-md shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2">
                  <Briefcase size={20} />
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] bg-white p-6 rounded-2xl shadow-md shadow-pink-200/50 border border-pink-100 hover-lift">
                  <div className="flex flex-col mb-2">
                    <span className="text-pink-400 font-extrabold text-sm mb-1 uppercase tracking-wider">Feb 2018 - Jul 2019</span>
                    <h3 className="text-xl font-bold text-gray-900">Social Media Specialist</h3>
                    <h4 className="text-md font-bold text-pink-400">Andaf Corporation</h4>
                  </div>
                  <ul className="text-sm text-gray-700 list-disc pl-5 space-y-2 marker:text-pink-400">
                    <li>Produced copywriting for social media caption to be published everyday.</li>
                    <li>Designed 100+ daily content on Canva.</li>
                    <li>Executed social media ads campaign (Facebook and Instagram) for clients with Awareness and Traffic campaign objective with monthly ad spent IDR 300,000 to 500,000.</li>
                    <li>Generated monthly report for 8+ retail client projects consist of MSME F&B, educational courses, laundry, etc with a retention rate 80%.</li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* PORTFOLIO SECTION */}
        <section id="portfolio" className="py-24 bg-pink-50 overflow-hidden" data-testid="portfolio-section">

          <div className="max-w-6xl mx-auto px-6 mb-12">
            <div className="text-center reveal reveal-up">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Featured Projects & Clients</h2>
              <div className="h-1.5 w-24 bg-pink-400 mx-auto rounded-full"></div>
              <p className="text-gray-600 mt-4 max-w-xl mx-auto">
                A selection of brands and campaigns I have successfully managed. Click on any brand to view their Instagram page!
              </p>
            </div>
          </div>

          <div className="w-full relative pb-12 overflow-x-hidden">
            {/* Adding gradient masks for a smooth fade effect on the left and right edges */}
            <div className="absolute left-0 top-0 bottom-0 w-16 md:w-48 bg-gradient-to-r from-pink-50 to-transparent z-10 pointer-events-none"></div>
            <div className="absolute right-0 top-0 bottom-0 w-16 md:w-48 bg-gradient-to-l from-pink-50 to-transparent z-10 pointer-events-none"></div>
            
            <div className="flex flex-row animate-marquee gap-8 md:gap-12 px-4">
              {/* We duplicate the array to create a seamless infinite loop effect */}
              {[...featuredClients, ...featuredClients].map((client, index) => (
                <a 
                  key={index} 
                  href={client.link} 
                  target="_blank" 
                  rel="noreferrer" 
                  className="flex flex-col items-center group flex-shrink-0 w-32 md:w-40"
                  data-testid={`client-${client.name.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  <div className="w-24 h-24 md:w-32 md:h-32 bg-white rounded-3xl shadow-sm shadow-pink-100 border border-pink-100 flex items-center justify-center overflow-hidden group-hover:shadow-2xl group-hover:shadow-pink-300 group-hover:border-pink-300 transition-all duration-300 group-hover:-translate-y-3 relative p-2">
                    {/* Placeholder avatar generated from brand name. You can replace the src with actual logo URLs later! */}
                    <img 
                      src={client.image || `https://ui-avatars.com/api/?name=${encodeURIComponent(client.name)}&background=F8C8DC&color=fff&size=128&bold=true`}
                      alt={client.name} 
                      className="w-full h-full object-contain rounded-2xl group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <span className="mt-6 text-sm md:text-base font-bold text-gray-700 text-center group-hover:text-pink-500 transition-colors whitespace-normal leading-tight">
                    {client.name}
                  </span>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* ADDITIONAL PROJECTS SECTION */}
        <section id="additional-projects" className="py-24 bg-white" data-testid="additional-projects-section">
          <div className="max-w-6xl mx-auto px-6">
            <div className="text-center mb-16 reveal reveal-up">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Additional Projects</h2>
              <div className="h-1.5 w-24 bg-pink-400 mx-auto rounded-full"></div>
              <p className="text-gray-600 mt-4 max-w-xl mx-auto">
                Showcasing my voice-over talent and creative work
              </p>
            </div>

            {/* Projects Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              {additionalProjects[projectPage - 1]?.map((project, index) => (
                <div key={`page-${projectPage}-item-${index}`} className="hover-lift" style={{ transitionDelay: `${index * 100}ms` }}>
                  <div className="bg-pink-50 rounded-3xl overflow-hidden shadow-lg shadow-pink-100 border border-pink-100">
                    {project.type === 'video' ? (
                      <video 
                        key={`video-${projectPage}-${index}`}
                        controls
                        className="w-full aspect-video object-cover"
                        data-testid={`video-${projectPage}-${index}`}
                      >
                        <source src={project.url} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    ) : (
                      <img 
                        src={project.url} 
                        alt={project.title}
                        className="w-full aspect-video object-cover"
                        data-testid={`image-${projectPage}-${index}`}
                      />
                    )}
                    <div className="p-6">
                      <h3 className="text-xl font-bold text-gray-800 mb-2">{project.title}</h3>
                      <p className="text-gray-600 text-sm">{project.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            <div className="flex items-center justify-center gap-4">
              <button
                onClick={() => setProjectPage(prev => Math.max(1, prev - 1))}
                disabled={projectPage === 1}
                className={`w-12 h-12 rounded-full flex items-center justify-center transition-all ${
                  projectPage === 1 
                    ? 'bg-pink-100 text-pink-300 cursor-not-allowed' 
                    : 'bg-pink-400 text-white hover:bg-pink-500 shadow-md hover:shadow-lg'
                }`}
                data-testid="prev-page-btn"
              >
                <ChevronLeft size={24} />
              </button>

              <div className="flex gap-2">
                {[...Array(totalPages)].map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setProjectPage(index + 1)}
                    className={`w-10 h-10 rounded-full font-bold transition-all ${
                      projectPage === index + 1
                        ? 'bg-pink-500 text-white shadow-md'
                        : 'bg-pink-100 text-pink-600 hover:bg-pink-200'
                    }`}
                    data-testid={`page-${index + 1}-btn`}
                  >
                    {index + 1}
                  </button>
                ))}
              </div>

              <button
                onClick={() => setProjectPage(prev => Math.min(totalPages, prev + 1))}
                disabled={projectPage === totalPages}
                className={`w-12 h-12 rounded-full flex items-center justify-center transition-all ${
                  projectPage === totalPages 
                    ? 'bg-pink-100 text-pink-300 cursor-not-allowed' 
                    : 'bg-pink-400 text-white hover:bg-pink-500 shadow-md hover:shadow-lg'
                }`}
                data-testid="next-page-btn"
              >
                <ChevronRight size={24} />
              </button>
            </div>

            <p className="text-center text-gray-500 text-sm mt-4">
              Page {projectPage} of {totalPages}
            </p>
          </div>
        </section>

        {/* CONTACT SECTION */}
        <section id="contact" className="py-24 bg-pink-100" data-testid="contact-section">
          <div className="max-w-6xl mx-auto px-6">
            <div className="bg-pink-50 rounded-[2.5rem] p-8 md:p-16 shadow-lg shadow-pink-200/50 border border-pink-200">
              <div className="flex flex-col md:flex-row gap-16">
                
                {/* Contact Info */}
                <div className="w-full md:w-5/12 space-y-8 reveal reveal-left delay-100">
                  <div>
                    <h2 className="text-4xl font-extrabold text-gray-900 mb-4">Let's Connect!</h2>
                    <p className="text-gray-700 leading-relaxed text-lg">
                      I'm currently looking for new opportunities and my inbox is always open. Whether you have a question or just want to say hi, I'll try my best to get back to you!
                    </p>
                  </div>

                  <div className="space-y-6">
                    <a href="mailto:iretasalsabila9@gmail.com?subject=Hello%20Irene!%20Let's%20Connect" target="_blank" rel="noreferrer" className="flex items-center space-x-5 text-gray-700 hover:text-pink-600 transition-colors group" data-testid="email-link">
                      <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center shadow-md group-hover:shadow-lg border-2 border-transparent group-hover:border-pink-300 text-pink-500 transition-all">
                        <Mail size={24} />
                      </div>
                      <span className="font-bold text-lg">iretasalsabila9@gmail.com</span>
                    </a>
                    <a href="https://wa.me/6287776147834" target="_blank" rel="noreferrer" className="flex items-center space-x-5 text-gray-700 hover:text-pink-600 transition-colors group" data-testid="whatsapp-link">
                      <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center shadow-md group-hover:shadow-lg border-2 border-transparent group-hover:border-pink-300 text-pink-500 transition-all">
                        <WhatsAppIcon size={24} />
                      </div>
                      <span className="font-bold text-lg">+62 877 7614 7834</span>
                    </a>
                  </div>

                  <div className="pt-4">
                    <h4 className="font-bold text-gray-900 mb-6 uppercase tracking-wider text-sm">Social Profiles</h4>
                    <div className="flex space-x-4">
                      <a href="https://www.linkedin.com/in/iretasalsabila/" target="_blank" rel="noreferrer" className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-pink-500 hover:bg-[#0077b5] hover:text-white transition-all shadow-md hover:shadow-lg border border-pink-100" data-testid="linkedin-link">
                        <Linkedin size={22} />
                      </a>
                      <a href="https://www.instagram.com/ireeennne___" target="_blank" rel="noreferrer" className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-pink-500 hover:bg-gradient-to-tr hover:from-yellow-400 hover:via-pink-500 hover:to-purple-500 hover:text-white transition-all shadow-md hover:shadow-lg border border-pink-100" data-testid="instagram-link">
                        <Instagram size={22} />
                      </a>
                      <a href="https://www.tiktok.com/@ireeennn___" target="_blank" rel="noreferrer" className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-pink-500 hover:bg-black hover:text-white transition-all shadow-md hover:shadow-lg border border-pink-100" data-testid="tiktok-link">
                        <TikTokIcon className="w-[20px] h-[20px]" />
                      </a>
                    </div>
                  </div>
                </div>

                {/* Contact Form */}
                <div className="w-full md:w-7/12 reveal reveal-right delay-300">
                  <form className="space-y-6 bg-white p-10 rounded-3xl shadow-xl shadow-pink-100 border border-pink-100" onSubmit={handleWhatsAppSubmit} data-testid="contact-form">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="space-y-2">
                        <label className="text-sm font-bold text-gray-700">Your Name</label>
                        <input 
                          type="text" 
                          name="user_name"
                          required
                          className="w-full px-5 py-4 rounded-xl bg-pink-50/50 border border-pink-200 focus:ring-4 focus:ring-pink-200 focus:border-pink-400 outline-none transition-all font-medium"
                          placeholder="John Doe"
                          data-testid="input-name"
                        />
                      </div>
                      <div className="space-y-2">
                        <label className="text-sm font-bold text-gray-700">Email Address</label>
                        <input 
                          type="email" 
                          name="user_email"
                          required
                          className="w-full px-5 py-4 rounded-xl bg-pink-50/50 border border-pink-200 focus:ring-4 focus:ring-pink-200 focus:border-pink-400 outline-none transition-all font-medium"
                          placeholder="john@example.com"
                          data-testid="input-email"
                        />
                      </div>
                    </div>
                    <div className="space-y-2">
                      <label className="text-sm font-bold text-gray-700">Subject</label>
                      <input 
                        type="text" 
                        name="user_subject"
                        required
                        className="w-full px-5 py-4 rounded-xl bg-pink-50/50 border border-pink-200 focus:ring-4 focus:ring-pink-200 focus:border-pink-400 outline-none transition-all font-medium"
                        placeholder="Opportunity / Collaboration"
                        data-testid="input-subject"
                      />
                    </div>
                    <div className="space-y-2">
                      <label className="text-sm font-bold text-gray-700">Message</label>
                      <textarea 
                        name="user_message"
                        rows="5"
                        required
                        className="w-full px-5 py-4 rounded-xl bg-pink-50/50 border border-pink-200 focus:ring-4 focus:ring-pink-200 focus:border-pink-400 outline-none transition-all resize-none font-medium"
                        placeholder="Write your message here..."
                        data-testid="input-message"
                      ></textarea>
                    </div>
                    <button 
                      type="submit"
                      className="w-full py-4 bg-pink-500 hover:bg-pink-600 text-white font-extrabold text-lg rounded-xl flex items-center justify-center space-x-2 transition-all shadow-md hover:shadow-lg shadow-pink-300 group"
                      data-testid="submit-btn"
                    >
                      <span>Send Message</span>
                      <Send size={20} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                    </button>
                  </form>
                </div>

              </div>
            </div>
          </div>
        </section>

      </main>

      {/* FOOTER */}
      <footer className="bg-pink-100 border-t border-pink-200 py-10 reveal reveal-up" data-testid="footer">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-gray-600 font-medium text-sm">
            © {new Date().getFullYear()} Ireta Salsabila Putri. All rights reserved.
          </div>
          <div className="flex space-x-8 text-sm font-bold">
            <button onClick={() => scrollTo('home')} className="text-gray-600 hover:text-pink-600 transition-colors">Home</button>
            <button onClick={() => scrollTo('about')} className="text-gray-600 hover:text-pink-600 transition-colors">About</button>
            <button onClick={() => scrollTo('portfolio')} className="text-gray-600 hover:text-pink-600 transition-colors">Portfolio</button>
          </div>
        </div>
      </footer>

    </div>
  );
};

export default App;
